import { sendEvent } from "../metrics/events";

const IFRAME_CONTAINER = `<div x-data="$store.__iframe_data" x-bind="container" :id="containerId" class="fixed inset-0 z-9999 pt-12 pb-12 px-0 sm:p-12 w-auto h-auto flex justify-center items-stretch md:text-lg bg-black/70"><button x-bind="button" class="absolute top-0 right-0 z-50 flex items-center justify-center mt-2 mr-2 sm:mt-2 sm:mr-2 text-gray-50 sm:hover:text-gray-950 rounded-full sm:hover:bg-gray-50 transition-colors duration-300"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-9 h-9 sm:w-9 sm:h-9"><path d="M18 6 6 18"/><path d="m6 6 12 12"/></svg></button><div x-bind="wrapper" class="relative flex-1 p-4 bg-white sm:rounded-2xl overflow-hidden"><iframe x-bind="iframe" frameborder="0" class="w-full h-full"></iframe></div></div>`;

function createIframeContainer(store) {
  const el = document.createElement("div");
  el.innerHTML = IFRAME_CONTAINER;
  document.body.appendChild(el.firstElementChild);
  store.isСreated = true;
}

function createIframePlugin() {
  Alpine.store("__iframe_data", {
    iframeLink: "about:blank",
    _show: false,
    customClass: "",
    isСreated: false,
    containerId: "__iframe_container",
    isShowIframe() {
      return this._show;
    },
    openIframe(link, customClass = "", metricsId = "") {
      this.customClass = customClass;
      this.iframeLink = link;
      this._show = true;
      metricsId && sendEvent("iframe", metricsId);
    },
    closeIframe() {
      this._show = false;
      this.iframeLink = "about:blank";
    },
    container: {
      "x-cloak": true,
      "x-show"() {
        return this.isShowIframe();
      },
      "@keydown.window.escape"() {
        return this.closeIframe();
      },
    },
    button: {
      "@click"() {
        this.closeIframe();
      },
    },
    wrapper: {
      "x-cloak": true,
      "x-show"() {
        return this.isShowIframe();
      },
      "@click.outside"() {
        this.closeIframe();
      },
      "x-trap.inert.noscroll"() {
        return this.isShowIframe();
      },
      ":class"() {
        return this.customClass;
      },
      "x-transition:enter": "ease-out duration-300",
      "x-transition:enter-start": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
      "x-transition:enter-end": "opacity-100 translate-y-0 sm:scale-100",
      "x-transition:leave": "ease-in duration-200",
      "x-transition:leave-start": "opacity-100 translate-y-0 sm:scale-100",
      "x-transition:leave-end": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
    },
    iframe: {
      "x-cloak": true,
      "x-show"() {
        return this.isShowIframe();
      },
      "x-effect"() {
        const targetUrl = this.$data.iframeLink;
        this.$nextTick(() => {
          this.$el.contentWindow.location.replace(targetUrl);
        });
      },
    },
  });
  Alpine.directive("iframe-modal", (el, { value, modifiers, expression }, { Alpine, effect, cleanup, evaluate }) => {
    const store = Alpine.store("__iframe_data");
    let params;
    if (!expression) {
      expression = el.getAttribute("x-data");
    }
    params = evaluate(expression);

    if (typeof params === "string" || params instanceof String) {
      params = { link: params };
    }
    if (!store.isСreated) {
      createIframeContainer(store);
    }
    let click = function (event) {
      store.openIframe(params.link, params.customClass || "", params.metricsId || "");
    };
    el.addEventListener("click", click);
    cleanup(() => {
      el.removeEventListener("click", click);
    });
  });
}

export { createIframePlugin };
